import { render, staticRenderFns } from "./Surveillance.vue?vue&type=template&id=168c4985&scoped=true&"
import script from "./Surveillance.vue?vue&type=script&lang=js&"
export * from "./Surveillance.vue?vue&type=script&lang=js&"
import style0 from "./Surveillance.vue?vue&type=style&index=0&id=168c4985&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168c4985",
  null
  
)

export default component.exports